export default "/assets/copy-meal-purple.svg";